import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/home';

export default function FeaturedSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="text-xs font-medium text-secondary-600 uppercase tracking-wider block mb-3">
            Editor&apos;s Pick
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            编辑精选推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            每部都是精挑细选，口碑与热度双重认证
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <Link
            to={`/article/${featuredComics[0].id}`}
            className="group bg-foreground-900 rounded-2xl p-8 flex flex-col justify-between min-h-[380px] hover:-translate-y-1 transition-all duration-300"
          >
            <div>
              <div className="w-12 h-12 rounded-full bg-accent-500/20 flex items-center justify-center mb-6">
                <span className="text-accent-400 font-bold font-heading text-lg">TOP</span>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold font-heading text-background-50 leading-tight">
                {featuredComics[0].title}
              </h3>
              <p className="text-sm text-background-300 mt-3 italic">{featuredComics[0].subtitle}</p>
              <p className="text-sm text-background-400 mt-6 leading-relaxed line-clamp-3">
                {featuredComics[0].description}
              </p>
            </div>
            <div className="flex items-center justify-between mt-8">
              <span className="text-xs text-background-500 bg-background-800 rounded-full px-3 py-1">
                {featuredComics[0].category}
              </span>
              <span className="text-lg font-bold font-heading text-accent-400">{featuredComics[0].rating}</span>
            </div>
          </Link>

          <Link
            to={`/article/${featuredComics[1].id}`}
            className="group relative rounded-2xl overflow-hidden min-h-[380px] hover:-translate-y-1 transition-all duration-300"
          >
            <img
              src={featuredComics[1].image}
              alt={featuredComics[1].title}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent" />
            <div className="absolute top-4 left-4">
              <span className="bg-accent-500/90 text-background-50 text-xs font-medium px-3 py-1.5 rounded-full flex items-center gap-1.5">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-fire-fill"></i>
                </span>
                {featuredComics[1].category}
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <h3 className="text-2xl md:text-3xl font-bold font-heading text-white leading-tight">
                {featuredComics[1].title}
              </h3>
              <p className="text-sm text-white/70 mt-2 italic">{featuredComics[1].subtitle}</p>
              <div className="flex items-center gap-3 mt-4">
                <span className="text-lg font-bold font-heading text-accent-400">{featuredComics[1].rating}</span>
                <span className="text-xs text-white/50">{featuredComics[1].description}</span>
              </div>
            </div>
          </Link>

          <Link
            to={`/article/${featuredComics[2].id}`}
            className="group bg-background-50 rounded-2xl border border-background-200/70 p-8 flex flex-col justify-between min-h-[380px] hover:-translate-y-1 transition-all duration-300"
          >
            <div>
              <div className="text-5xl font-bold font-heading text-primary-600 mb-4">
                {featuredComics[2].rating}
              </div>
              <h3 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 leading-tight">
                {featuredComics[2].title}
              </h3>
              <p className="text-sm text-foreground-400 mt-3 italic">{featuredComics[2].subtitle}</p>
              <p className="text-sm text-foreground-500 mt-6 leading-relaxed line-clamp-3">
                {featuredComics[2].description}
              </p>
            </div>
            <div className="mt-8">
              <div className="w-full h-40 rounded-xl overflow-hidden">
                <img
                  src={featuredComics[2].image}
                  alt={featuredComics[2].title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="flex items-center justify-between mt-4">
                <span className="text-xs text-foreground-500 bg-background-100 rounded-full px-3 py-1">
                  {featuredComics[2].category}
                </span>
                <span className="text-xs text-accent-600 font-medium flex items-center gap-1">
                  查看详情
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </span>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}